export function getLastValue(value) {
    return value[value.length - 1];
}
export function merge(target, ...sources) {
    for (const source of sources) {
        for (const key in source) {
            if (source[key] === null)
                continue;
            target[key] = replaceValues(target[key], source[key]);
        }
    }
    return target;
}
function isObject(obj) {
    return obj && obj.constructor === Object;
}
function replaceValues(currentValue, newValue) {
    if (Array.isArray(currentValue) && Array.isArray(newValue)) {
        return newValue.map((value, index) => replaceValues(currentValue[index], value));
    }
    if (isObject(currentValue) && isObject(newValue)) {
        return merge(currentValue, newValue);
    }
    return newValue;
}
//# sourceMappingURL=utils.js.map